import React from "react";
import { useTranslation } from "react-i18next";

import { getMonthsTexts } from "./utils";
import { Props } from "./types";
import styles from "./styles.scss";

function Month({ month, weekIndex }: Props) {
  const { t } = useTranslation();
  const monthsNames = getMonthsTexts(t);
  const day = (month[Math.round(month.length / 2)] || month[0])[0];

  return (
    <div className={styles.month}>
      <p className={styles.name}>
        {monthsNames[day.month - 1] || monthsNames[0]} {day.year} |{" "}
        <span className={styles.week}>
          {t("timeSheet.week")} {weekIndex}
        </span>
      </p>
    </div>
  );
}

export { Month };
